import {Header, List, Segment} from "semantic-ui-react";
import React from "react";

const FAQ = () =>
    <Segment>
        <Header as='h3'>
            FAQ
        </Header>
        <List>
            <List.Item>
                <List.Content>
                    <List.Header>Kan man noen gang melde seg av uten ølstraff?</List.Header>
                    Ja, hvis det er 11 eller 13+ påmeldte spillere så kan man melde seg av uten straff.
                </List.Content>
            </List.Item>
            <List.Item>
                <List.Content>
                    <List.Header>Koster det noe å langtidsavmelde seg?</List.Header>
                    Langtidsavmelding koster 1 øl per påbegynte måned.
                </List.Content>
            </List.Item>
            <List.Item>
                <List.Content>
                    <List.Header>Når kan man melde på gjestespillere?</List.Header>
                    Hvis det er under 24 timer igjen og færre enn 10 påmeldte kan man alltid melde på gjestespillere.
                    Når det er mer enn 24 timer igjen kan man melde på gjestespiller hvis påmeldte og ubesvarte
                    til sammen er under 10 spillere.
                </List.Content>
            </List.Item>
            <List.Item>
                <List.Content>
                    <List.Header>Hvilken øl snakker vi om her?</List.Header>
                    Standard halvliter, omtrent 40,- per øl.
                </List.Content>
            </List.Item>
            <List.Item>
                <List.Content>
                    <List.Header>Jeg har halv plass, må jeg være med på dette registreringstullet?</List.Header>
                    Ja, per nå er det ikke laget noe eget opplegg for de med halv plass. Endringer kan skje, spesielt
                    hvis det etter hvert gjelder flere spillere.
                </List.Content>
            </List.Item>
            <List.Item>
                <List.Content>
                    <List.Header>Noe uforutsett har oppstått. Kan jeg slippe ølstraff?</List.Header>
                    Eneste gyldige grunn er dødsfall (eget).
                </List.Content>
            </List.Item>
        </List>
    </Segment>;

export default FAQ;



// WEBPACK FOOTER //
// ./src/Components/FAQ.js